import { render, staticRenderFns } from "./teachingInfo.vue?vue&type=template&id=453c4966&scoped=true"
import script from "./teachingInfo.vue?vue&type=script&lang=ts"
export * from "./teachingInfo.vue?vue&type=script&lang=ts"
import style0 from "./teachingInfo.vue?vue&type=style&index=0&id=453c4966&prod&lang=scss&scoped=true"
import style1 from "./teachingInfo.vue?vue&type=style&index=1&id=453c4966&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c4966",
  null
  
)

export default component.exports